export * from './api.service';
export * from './authentication.service';
export * from './loading.service';
export * from './menu.service';
export * from './profile-picture.service';
export * from './temporary-url.service';
export * from './ticket.service';
export * from './ticket-attachment.service';
export * from './token.service';
export * from './user.service';
export * from './notification.service';
export * from './role.service';



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/services/index.ts